// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchFilters_root__12Klr","filtersWrapper":"SearchFilters_filtersWrapper__3NpEP","filtersInner":"SearchFilters_filtersInner__lsCEu","filter":"SearchFilters_filter__2Il5m"};